import {useQuery} from '@tanstack/react-query'
import {QUOTE_API} from '../services/quote.http'
import {QUOTE_QUERY_KEYS} from './keys'

export const useGetQuote = ({quoteId}: {quoteId?: string}) => {
    return useQuery({
        queryKey: [QUOTE_QUERY_KEYS.quote, quoteId],
        queryFn: () => QUOTE_API.getQuote(quoteId),
        enabled: !!quoteId
    })
}
